import { Box, Skeleton, TextField } from '@mui/material';
import { DialogWrapper } from '../../../shared/components/common/dialogWrapper';
import TextWrapper from '../../../shared/formUtilities/useTextWrapper';
import ButtonWrapper from '../../../shared/formUtilities/useButton';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import OTPImage from '../../../assets/images/otp.png';
import {
	getAdminAuthQRCode,
	getFirstName,
	getLoginInfo,
	loginUsingToken,
	submitAdminOTPVerificationCode,
	verifyAdminAuth,
} from '../../../services/authService';
import SettingsIcon from '@mui/icons-material/Settings';
import OTPInput from 'otp-input-react';
import { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Toaster } from '../../../shared/components/common/toaster';
import LockResetIcon from '@mui/icons-material/LockReset';

export const OTPAuthenticationDialog = ({ state, onClose = (e) => {} }) => {
	const [OTP, setOTP] = useState('');
	const [authKey, setAuthKey] = useState('');
	const [authURI, setAuthURI] = useState('');
	const [isShowAuthScreen, setIsShowAuthScreen] = useState(false);
	const [useRecovery, setUseRecovery] = useState(false);
	const [recoveryCodes, setRecoveryCodes] = useState([]);
	const [loginValues, setLoginValue] = useState(getLoginInfo());
	const [loading, setLoading] = useState(false);
	const onVerify = () => {
		const form = {
			code: OTP,
		};
		setLoading(true);
		verifyAdminAuth(form)
			.then((resp) => {
				loginUsingToken(resp.data);
				onClose(true);
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	useEffect(() => {
		setLoginValue(getLoginInfo());
	}, [state]);

	const onChangeAuthScreen = (authState = false) => {
		if (authState) {
			getQRCode();
		} else {
			setAuthKey('');
			setAuthURI('');
		}
		setOTP('');
		setIsShowAuthScreen(authState);
	};

	const getQRCode = () => {
		getAdminAuthQRCode().then((resp) => {
			setAuthKey(resp.data?.key);
			setAuthURI(resp.data?.authenticatorUri);
		});
	};

	const onAuthVerification = () => {
		if (OTP) {
			const form = {
				code: OTP,
			};
			setLoading(true);
			submitAdminOTPVerificationCode(form)
				.then((resp) => {
					setLoading(false);
					setIsShowAuthScreen(false);
					setRecoveryCodes(
						resp.data?.recoveryCodes ? resp.data?.recoveryCodes : []
					);
				})
				.catch((err) => {
					setLoading(false);
				});
		}
	};

	const getOTPSection = () => {
		return (
			<OTPInput
				className="!grid grid-cols-6 gap-3"
				placeholder={['*', '*', '*', '*', '*', '*']}
				inputClassName="border border-[#33CD87] rounded-sm !m-0"
				value={OTP}
				onChange={setOTP}
				autoFocus
				OTPLength={6}
				otpType="number"
			/>
		);
	};
	return (
		<>
			<DialogWrapper
				maxWidth="xs"
				state={state}
				onClose={() => {
					onClose(false);
				}}
				title={``}
				content={
					!isShowAuthScreen ? (
						<Box className="flex flex-col flex-0 justify-center items-center !text-sm">
							<img
								className="w-28"
								src={OTPImage}
								alt="otpImage"></img>
							<TextWrapper
								classList="!font-bold !text-xl !mb-3"
								text="Verification"></TextWrapper>
							{getFirstName() ? (
								<TextWrapper
									classList="!font-bold"
									text={`Hello ${getFirstName()}`}></TextWrapper>
							) : null}

							<TextWrapper
								classList="caption !text-center !mb-3 !text-sm"
								text={
									<span>
										<span>
											Please enter the verification code from your authenticator
											application
										</span>
										{!loginValues?.mfaConfigured ? (
											<span>
												, if you didn’t configure the authenticator application
												yet, click the link below
											</span>
										) : (
											<span>.</span>
										)}
									</span>
								}></TextWrapper>
							{!loginValues?.mfaConfigured ? (
								<Box className="flex flex-row flex-0 items-center">
									<SettingsIcon color="primary"></SettingsIcon>
									<span
										onClick={() => {
											onChangeAuthScreen(true);
										}}
										className="link">
										Configure Authenticator App
									</span>
								</Box>
							) : null}

							{recoveryCodes?.length ? (
								<Box className="flex flex-col justify-center items-center flex-0 !mt-4">
									<TextWrapper
										text="Recovery Codes"
										classList="!font-bold !text-lg !mb-2"></TextWrapper>
									<Box className="bg-[#fff8e9] flex flex-col flex-0 space-x-2 p-3 rounded-md">
										<TextWrapper
											text="Put these codes in a safe place"
											classList="!font-bold !text-md !text-center !mb-3"></TextWrapper>
										<TextWrapper
											classList="!text-center !mb-3 !text-sm"
											text="If you lose your device and don't have the recovery codes you will lose access to your account"></TextWrapper>
										<Box className="grid grid-cols-3 md:grid-cols-5 gap-2">
											{recoveryCodes.map((resp, index) => {
												return (
													<TextWrapper
														key={index}
														text={resp}
														classList="!bg-black !px-1 !py-[1px] !text-white !text-xs !text-center rounded"></TextWrapper>
												);
											})}
										</Box>
										<span
											onClick={() => {
												setOTP('');
												setUseRecovery(!useRecovery);
											}}
											className="link mt-4 text-center">
											<LockResetIcon className="!text-[16px] mx-1"></LockResetIcon>
											{!useRecovery
												? 'Use Recovery Code'
												: 'Use Verification Code'}
										</span>
									</Box>
								</Box>
							) : null}
							<Box className={`mt-5 ${useRecovery ? 'w-full' : ''}`}>
								{!useRecovery ? (
									getOTPSection()
								) : (
									<>
										<TextWrapper
											type="caption"
											text={'Verification Code'}></TextWrapper>
										<TextField
											fullWidth={true}
											type="number"
											value={OTP}
											size="small"
											onChange={(e) => {
												setOTP(e.target.value);
											}}></TextField>
									</>
								)}
							</Box>
						</Box>
					) : (
						<Box className="flex flex-col flex-0 justify-center items-center">
							<TextWrapper
								classList="!font-bold !text-xl !mb-3 !text-center"
								text="Configure Two-Factor Authentication"></TextWrapper>
							<TextWrapper
								classList="caption !text-start !mb-3 !text-sm"
								text="To use an authenticator app go through the following steps:"></TextWrapper>
							<ul className="!text-sm">
								<li className="mb-2">
									<TextWrapper
										classList="caption !text-center !mb-3 !text-sm"
										text={
											<>
												<span className="!text-sm">
													Download a two-factor authenticator app Google
													Authenticator for
												</span>
												<a
													className="!text-sm mx-1"
													href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en">
													Android
												</a>
												and
												<a
													className="!text-sm ml-1"
													href="https://apps.apple.com/us/app/google-authenticator/id388497605">
													iOS
												</a>
												.
											</>
										}></TextWrapper>
								</li>
								<li className="mb-2">
									<TextWrapper
										classList="caption !text-center !text-xs"
										text={
											<span className="!text-sm">
												<span>
													Scan the QR Code or enter this key <br />
												</span>
												{authKey ? (
													<Box className="flex flex-0 items-start">
														<span className="bg-black text-white px-1 py-[1px] rounded-sm !text-xs">
															{authKey}
															<br />
														</span>
														<ContentCopyIcon
															onClick={() => {
																Toaster({ msg: 'Copied', isError: false });
																navigator.clipboard.writeText(authKey);
															}}
															className="!text-sm mt-1 cursor-pointer mx-1"></ContentCopyIcon>
													</Box>
												) : (
													<Skeleton
														variant="text"
														sx={{ fontSize: '2rem', width: '80%' }}
													/>
												)}

												<span>
													into your two factor authenticator app. Spaces and
													casing do not matter.
												</span>
											</span>
										}></TextWrapper>
									<Box className="flex justify-center flex-0 my-8">
										{authURI ? (
											<QRCode
												style={{
													border: '0px',
													height: 'auto',
													maxWidth: '140px',
													width: '140px',
												}}
												value={authURI}
											/>
										) : (
											<Box>
												<Skeleton
													variant="rectangular"
													sx={{ height: '140px', width: '140px' }}
												/>
											</Box>
										)}
									</Box>
								</li>
								<li className="mb-2">
									<TextWrapper
										classList="caption !text-center !text-sm"
										text={
											'Once you have scanned the QR code or input the key above, your two factor authentication app will provide you with a unique code. Enter the code in the confirmation box below.'
										}></TextWrapper>
									<Box className="mt-6 flex justify-center flex-0">
										{getOTPSection()}
									</Box>
								</li>
							</ul>
						</Box>
					)
				}
				actions={
					<Box className="flex items-center">
						<ButtonWrapper
							disabled={loading}
							hideBtn={!isShowAuthScreen}
							classList="!mr-3"
							variant={'outlined'}
							icon={<ArrowBackIcon></ArrowBackIcon>}
							type="button"
							onClick={() => {
								onChangeAuthScreen(false);
							}}
							label="Back"></ButtonWrapper>
						<ButtonWrapper
							loading={loading}
							disabled={!OTP || (!useRecovery ? OTP?.length < 6 : false)}
							icon={<HowToRegIcon></HowToRegIcon>}
							type="button"
							onClick={() => {
								if (isShowAuthScreen) {
									onAuthVerification();
								} else {
									onVerify();
								}
							}}
							label="Verify"></ButtonWrapper>
					</Box>
				}></DialogWrapper>
		</>
	);
};
